import TelecollectDetailSaleNested from './TelecollectDetailSaleNested'
export default TelecollectDetailSaleNested
